/**
 * @fileoverview Hook UI Layer para gestión del estado y handlers del lightbox de imágenes en AreaChatWindowMC.
 * @module useAreaChatWindowLightboxUI
 * @category Hook - UI Layer
 * @since 1.0.0
 * @version 1.0.0
 */
import { useState, useCallback } from "react";

/**
 * Hook UI Layer para gestión de lightbox de imágenes en AreaChatWindowMC.
 *
 * @returns {Object} Estado y handlers del lightbox
 * @property {boolean} lightboxOpen - Si el lightbox está abierto
 * @property {string|number|null} selectedImageId - ID de la imagen seleccionada
 * @property {function} openLightbox - Abre el lightbox con una imagen
 * @property {function} closeLightbox - Cierra el lightbox y limpia selección
 */
function useAreaChatWindowLightboxUI() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImageId, setSelectedImageId] = useState(null);

  /**
   * Abre el lightbox con la imagen seleccionada
   * @param {string|number} imageId
   */
  const openLightbox = useCallback((imageId) => {
    setSelectedImageId(imageId);
    setLightboxOpen(true);
  }, []);

  /**
   * Cierra el lightbox y limpia selección
   */
  const closeLightbox = useCallback(() => {
    setLightboxOpen(false);
    setSelectedImageId(null);
  }, []);

  return {
    lightboxOpen,
    selectedImageId,
    openLightbox,
    closeLightbox,
  };
}

export default useAreaChatWindowLightboxUI;
